import { mdiChevronLeft } from '@mdi/js';
import Icon from '@mdi/react';
import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Col, Form, Input, Label } from 'reactstrap';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  detailedTimesheetValidationSchema,
  populateFormData,
  detailedTimesheetIninitialValues,
} from './constants';
import { fetchManualEventById } from '../../../store/apis/eventService';

import './DetailedTimesheet.scss';

function DetailedTimesheet() {
  document.title = 'Detailed Timesheet | Envision - Daikin';
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const { ID, CoCd } = Object.fromEntries(query);
  const { control, setValue, reset } = useForm({
    defaultValues: detailedTimesheetIninitialValues,
    resolver: yupResolver(detailedTimesheetValidationSchema),
    mode: 'onChange',
  });

  const { data: timesheetData } = useQuery({
    queryKey: ['detailedTimesheet', ID],
    queryFn: () =>
      fetchManualEventById({
        eventId: ID,
        coCd: CoCd || null,
      }),
    enabled: !!ID,
  });

  useEffect(() => {
    if (timesheetData && timesheetData.length > 0) {
      const formData = populateFormData(timesheetData?.[0]);
      reset(formData);
      setValue('startTime', formData.startTime || '00:00');
      setValue('endTime', formData.endTime || '00:00');
    }
  }, [timesheetData]);

  return (
    <div className="page-content">
      <div className="dts-header d-flex flex-row align-items-center gap-2">
        <div>
          <button
            type="button"
            onClick={() => window.history.back()}
            className="dts-back-btn p-0 d-flex flex-row align-items-center gap-1"
          >
            <Icon path={mdiChevronLeft} size={1.1} color="#017EBD" />
            <span className="back fs-5">Back</span>
          </button>
        </div>
        <div className="dts-separator" />
        <div className="dts-title fs-5">Attendance Statistics</div>
      </div>
      <div>
        <Form className="d-flex flex-column gap-3">
          <Col>
            <Label>Subject</Label>
            <Controller
              name="subject"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  placeholder="Enter Subject"
                  type="text"
                  name="subject"
                  className="external-filter-input"
                  disabled
                />
              )}
            />
          </Col>
          <div className="d-flex flex-row gap-2">
            <Col>
              <Label>Start Date</Label>
              <Controller
                name="startDate"
                control={control}
                render={({ field }) => (
                  <Input
                    {...field}
                    type="date"
                    name="startDate"
                    className="external-filter-input form-control"
                    disabled
                  />
                )}
              />
            </Col>
            <Col>
              <Label>End Date</Label>
              <Controller
                name="endDate"
                control={control}
                render={({ field }) => (
                  <Input
                    {...field}
                    type="date"
                    name="endDate"
                    className="external-filter-input form-control"
                    disabled
                  />
                )}
              />
            </Col>
          </div>
          <div className="d-flex flex-row gap-2">
            <Col>
              <Label>Start Time</Label>
              <Controller
                name="startTime"
                control={control}
                render={({ field }) => (
                  <Input
                    {...field}
                    type="time"
                    name="startTime"
                    className="external-filter-input form-control"
                    disabled
                  />
                )}
              />
            </Col>
            <Col>
              <Label>End Time</Label>
              <Controller
                name="endTime"
                control={control}
                render={({ field }) => (
                  <Input
                    {...field}
                    type="time"
                    name="endTime"
                    className="external-filter-input form-control"
                    disabled
                  />
                )}
              />
            </Col>
          </div>

          <Col>
            <Label>Comments</Label>
            <Controller
              name="comments"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  placeholder="Enter Comments"
                  name="comments"
                  type="textarea"
                  className="external-filter-input form-control"
                  disabled
                />
              )}
            />
          </Col>
        </Form>
      </div>
    </div>
  );
}

export default DetailedTimesheet;
